module.exports = __webpack_public_path__ + "img/empty-result.51eccf5.svg";